import React from 'react'
import omit from 'lodash/omit'
import PropTypes from 'prop-types'
import { FieldRenderProps } from 'react-final-form'
import FormGroup from '../FormGroup'
import { PROP_TYPE_REDUX_FORM_ELEMENT } from '../Forms/constants'
import { parseMessage } from '../Forms/utils'
import Input from '../Input'

type InputFieldProps = FieldRenderProps<string, HTMLElement>

const InputField = ({
  className,
  help,
  input,
  label,
  maxlength,
  meta,
  optional,
  required,
  inputClassName,
  ...props
}: InputFieldProps) => {
  const error = parseMessage(meta.error || props.error)?.toString()
  const success = parseMessage(props.success)?.toString()
  const touched = meta.touched || props.touched

  return (
    <FormGroup
      className={className}
      disabled={input.disabled}
      error={error}
      help={help}
      label={label}
      maxlength={maxlength}
      name={input.name}
      optional={optional}
      required={required}
      success={success}
      touched={touched}
      value={input.value}
    >
      <Input
        aria-describedby={`${input.name}-help-text ${input.name}-info-text`}
        error={error}
        required={required}
        success={success ?? false}
        touched={touched}
        maxLength={maxlength}
        className={inputClassName}
        {...omit(input, ['success', 'touched'])}
        {...omit(props, ['success', 'touched'])}
      />
    </FormGroup>
  )
}

InputField.propTypes = {
  ...PROP_TYPE_REDUX_FORM_ELEMENT,
} as PropTypes.ValidationMap<InputFieldProps>

export default InputField
